export const DISABLED = {
    BORDER: {
        DEFAULT: "#C6C8CC"
    },
    TEXT: {
        DEFAULT: "#666666"
    },
    BACKGROUND: {
        DEFAULT: "#EEEEEE"
    }
}